import { Capacitor } from "@capacitor/core";

// Dentro il binario nativo `window.location.origin` è `capacitor://localhost` su
// iOS e `https://localhost` su Android: un link costruito da lì non lo apre
// nessuno, e Firebase rifiuta il continue URI perché non è un dominio
// autorizzato. Sul web invece l'origine vera serve, perché gli ambienti di
// anteprima girano su domini diversi da quello di produzione.
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "https://puzzly.giadalabs.com";

export function publicBaseUrl() {
  if (Capacitor.isNativePlatform()) {
    return PUBLIC_URL.endsWith("/") ? PUBLIC_URL : `${PUBLIC_URL}/`;
  }
  return `${window.location.origin}${window.location.pathname}`;
}
